import { vaultPostRequest } from '../helpers';
import type { ICropVideoRequest } from './crop-video-request';
import type { ICropVideoResponse } from './crop-video-response';
import { cropVideoResponseSchema } from './crop-video-response';

export async function cropVideoApi(body: ICropVideoRequest): Promise<ICropVideoResponse> {
  return vaultPostRequest({ path: '/crop', body, schema: cropVideoResponseSchema });
}
